import styled from 'styled-components';
import { color } from 'styles/colors';

export const container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: flex-start;
  justify-content: flex-start;
  overflow: auto;
`;

export const noTags = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;

  > p {
    font-size: 1rem;
    color: ${color.interface.darkgray};
  }
`;

export const listTag = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const tag: any = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border: 1px solid ${color.interface.lightGray2};
  border-radius: 5px;

  > img {
    padding: 10px;
    width: 100px;
    height: 100px;
    border-radius: 5px;
    object-fit: fill;
  }
`;

export const imagBox = styled.div`
  flex: 1;
  min-width: 100px;
  max-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0px 10px 10px;

  > img {
    width: 100%;
    height: 80px;
    border-radius: 5px;
    object-fit: contain;
  }

  > svg {
    width: 100%;
    height: 80px;
    color: ${color.interface.lightGray};
  }
`;
export const infosAndBtns = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 540px) {
    flex-direction: column;
  }
`;

export const infos = styled.div`
  padding: 10px;
  width: 100%;
`;

export const btns = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  > svg {
    cursor: pointer;
    font-size: 1.5rem;
  }

  @media (max-width: 540px) {
    width: 100%;
    justify-content: flex-end;
  }
`;

interface ColorDivProps {
  backColor: string;
}

export const colorDiv = styled.div<ColorDivProps>`
  min-width: 10px;
  min-height: 100%;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: ${props => props.backColor};

  -webkit-box-shadow: 4px 0px 5px -3px rgba(0, 0, 0, 0.33);
  -moz-box-shadow: 4px 0px 5px -3px rgba(0, 0, 0, 0.33);
  box-shadow: 4px 0px 5px -3px rgba(0, 0, 0, 0.33);
`;

export const priority = styled.p`
  font-size: 0.8rem;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: ${color.interface.darkgray3};
`;

export const clusterName = styled.p`
  font-size: 0.8rem;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: ${color.interface.darkgray3};
`;

export const centralize = styled.div`
  width: 100%;
  height: 100%;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
